<template>
    <BModal id="des-modal"
            v-bind:no-close-on-backdrop=true
            dialogClass="modal-dialog-left modal-lg"
            bodyClass="p-3" v-model="modalShow" size="xl">
        <template #header>
            <h2>
                Історія повідомлень
            </h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect
                waves-themed" v-on:click="modalShow = !modalShow">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        <template #title>
            Історія повідомлень
        </template>
        
        <div class="description pl-1 pl-1">
            <BTable :items="items"    class="cursor-pointer"
                    @row-clicked="onRowClicked" :fields="fields" striped show-empty >
                
                <template #row-details="row">
                    <BCard >
                        <div v-html="row.item.mail"></div>
                    </BCard>
                </template>
            </BTable>
        </div>
        
        <template #footer>
            <div  class="main_buttons">
            
            </div>
        </template>
    </BModal>
</template>

<script>

import { BModal, BButton ,BOverlay,BTable,BCard} from 'bootstrap-vue-next';
export default {
    name: "application_history",
    
    props : {
        tender_id : {
            type : Number,
            required : true
        },
        app_id : {
            type : Number,
            required : true
        },
        
    },
    
    components: {
        BModal,
        BButton,
        BOverlay,
        BTable,
        BCard
    },
    
    data() {
        return {
            is_load : false,
            modalShow : false,
            items: [],
            fields : [
                { key: 'id', label: 'ID' },
                { key: 'added', label: 'Дата'  },
                { key: 'type_title', label: 'Тип'  },
                { key: 'email_from', label: 'Надіслав'  },
            ],
            
        }
    },
    
    created() {
        EventBus.$on('show_history',this.show);
        
    },
    
    methods: {
        onRowClicked(item, index) {
            item._showDetails = !item._showDetails
        },
        close() {
            this.modalShow = false;
            this.items = [];
        },
        
        show() {
            this.modalShow = true;
            this.loadHistory();
        },
        
        async loadHistory() {
            this.items = [];
            
            let url = "/tenders/sales/tenders/" + parseInt(this.tender_id) + "/applications/" + this.app_id + "/history";
            await api.get(url).then(({data}) => {
                if (data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(response => {
                console.log(response);
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
    }
}
</script>



<style scoped>

</style>